import React, { useState } from 'react'
import {
	CircularProgress,
	Typography,
	Button,
	Tabs,
	Tab,
	TextField,
	Fade,
} from '@material-ui/core'
import { withRouter } from 'react-router-dom'
import ForgotPasswordDialog from './ForgotPasswordDialog'

// styles
import useStyles from './styles'

// logo
import logo from './compkit.png'

// context
import { useUserDispatch, loginUser } from '../../context/UserContext'

// component
import Signup from '../signup'

function Login(props) {
	var classes = useStyles()

	// global
	var userDispatch = useUserDispatch()

	// local
	var [isLoading, setIsLoading] = useState(false)
	var [error, setError] = useState(null)
	var [activeTabId, setActiveTabId] = useState(0)
	var [loginValue, setLoginValue] = useState('')
	var [passwordValue, setPasswordValue] = useState('')
	var [dialogOpen, setDialogOpen] = useState(false)


	return (
		<div className={classes.container} >
			<div className={classes.formContainer}>
				<div className={classes.logotypeContainer}>
					<img src={logo} alt="logo" className={classes.logotypeImage} />
				</div>
				<div className={classes.form}>
					<Tabs
						value={activeTabId}
						onChange={(e, id) => setActiveTabId(id)}
						indicatorColor="primary"
						textColor="primary"
						centered
					>
						<Tab label="Login" classes={{ root: classes.tab }} />
						<Tab label="New User" classes={{ root: classes.tab }} />
					</Tabs>
					{activeTabId === 0 && (
						<React.Fragment>
							<Fade in={error}>
								<Typography
									color="secondary"
									className={classes.errorMessage}
								>
									Something is wrong with your login or password
								</Typography>
							</Fade>
							<TextField
								id="email"
								InputProps={{
									classes: {
										underline: classes.textFieldUnderline,
										input: classes.textField,
									},
								}}
								value={loginValue}
								onChange={e => setLoginValue(e.target.value)}
								margin="normal"
								placeholder="Email Address"
								type="email"
								fullWidth
							/>
							<TextField
								id="password"
								InputProps={{
									classes: {
										underline: classes.textFieldUnderline,
										input: classes.textField,
									},
								}}
								value={passwordValue}
								onChange={e => setPasswordValue(e.target.value)}
								margin="normal"
								placeholder="Password"
								type="password"
								fullWidth
							/>
							<div className={classes.formButtons}>
								{isLoading ? (
									<CircularProgress
										size={26}
										className={classes.loginLoader}
									/>
								) : (
										<Button
											disabled={
												loginValue.length === 0 ||
												passwordValue.length === 0
											}
											onClick={() =>
												loginUser(
													userDispatch,
													loginValue,
													passwordValue,
													props.history,
													setIsLoading,
													setError,
												)
											}
											variant="contained"
											color="primary"
											size="large"
										>
											Login
									</Button>
									)}
								<Button
									color="primary"
									size="large"
									className={classes.forgetButton}
									onClick={() => setDialogOpen(true)}
								>
									Forget Password
								</Button>
							</div>
						</React.Fragment>
					)}
					{activeTabId === 1 && <Signup />}
					<Typography color="primary" className={classes.copyright}>
						© 2019 CompKit, LLC. All rights reserved.
				</Typography>
				</div>

			</div>
			<ForgotPasswordDialog dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} />
		</div>
	)
}

export default withRouter(Login)
